var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_2726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6568 0.796875H47.3768C54.634 0.796875 60.5168 6.67969 60.5168 13.9369V47.6569C60.5168 54.9141 54.634 60.7969 47.3768 60.7969H13.6568C6.39966 60.7969 0.516846 54.9141 0.516846 47.6569V13.9369C0.516846 6.67969 6.39966 0.796875 13.6568 0.796875Z",
    fill: "url(#paint0_linear_62_2726)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7454 44.3459L19.7511 44.3477L17.6996 47.9009C16.9508 49.1979 15.2923 49.6423 13.9953 48.8934C12.6985 48.1446 12.2539 46.4862 13.0027 45.1891L14.514 42.5716L14.659 42.3204C14.918 41.9482 15.5572 41.3055 16.8357 41.4265C16.8357 41.4265 19.8444 41.753 20.0621 43.3167C20.0621 43.3167 20.0916 43.8312 19.7454 44.3459ZM48.8415 35.2709H42.4444C42.0087 35.2416 41.8187 35.0859 41.7437 34.9955L41.739 34.9873L34.8912 23.1265L34.8823 23.1323L34.4717 22.5436C33.7986 21.5142 32.7298 24.1467 32.7298 24.1467C31.4537 27.0802 32.911 30.4151 33.4189 31.4231L42.9303 47.8973C43.6789 49.1941 45.3373 49.6387 46.6346 48.8897C47.9314 48.1409 48.376 46.4824 47.6269 45.1854L45.2487 41.066C45.2026 40.9662 45.1224 40.6952 45.6101 40.6941H48.8415C50.3391 40.6941 51.5532 39.48 51.5532 37.9823C51.5532 36.4847 50.3391 35.2706 48.8415 35.2706V35.2709ZM36.4163 38.9571C36.4163 38.9571 36.7578 40.6941 35.4366 40.6941H11.7884C10.2908 40.6941 9.07669 39.48 9.07669 37.9823C9.07669 36.4847 10.2908 35.2706 11.7884 35.2706H17.8681C18.8497 35.2139 19.0822 34.6472 19.0822 34.6472L19.0878 34.65L27.0237 20.9044L27.0214 20.9039C27.166 20.6384 27.0455 20.3873 27.0247 20.3477L24.4037 15.8081C23.6548 14.5113 24.0992 12.8526 25.3962 12.1041C26.6933 11.3552 28.3517 11.7994 29.1005 13.0964L30.316 15.2018L31.5294 13.1001C32.2782 11.8034 33.9366 11.3587 35.2337 12.1078C36.5307 12.8566 36.9751 14.5148 36.2262 15.8119L25.1829 34.9392C25.1347 35.0557 25.1199 35.2385 25.4792 35.2706H32.0801L32.0815 35.3351C32.0815 35.3351 35.8967 35.3944 36.4163 38.9571Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_62_2726",
    x1: 30.5168,
    y1: 0.796875,
    x2: 30.5168,
    y2: 60.7969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17C9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A74E8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_2726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.516846 0.796875)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.371493ed989316985ada1c6e4d4820df.svg";
export { ForwardRef as ReactComponent };